import styled from "@emotion/styled";
import { Paper } from "@mui/material";

export const LeadDetailsSkeletonSectionContainer = styled(Paper)({
	display: "flex",
	flexDirection: "column",
	padding: "16px"
});
